module.exports = __webpack_public_path__ + "static/media/cpp.dabdad40.png";